module.exports = __webpack_public_path__ + "static/media/peer_image4.2ef58dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_image4.png
// module id = 2651
// module chunks = 0